import { getMemberWalletProviderWalletSeamless, getMemberWalletSeamlessProvider } from '@pm/super-library-2/modules/seamless';
import { getMainWallet, getMemberProviderWallet } from '@pm/super-library-2/modules/member';

import { seamlessConstant, walletConstant } from '../constant';

export const walletAction = {
    updateLoadWallet,
    updateWallet,
    updateProviderWallets,
    updateDepositWithdrawDecimalSettings,
    fetchMainWallet,
    fetchProviderWallets,
};

function updateLoadWallet(loadWallet) {
    return (dispatch) => {
        dispatch({ type: walletConstant.UDPATE_LOAD_WALLET, payload: { loadWallet } });
    };
}

function updateWallet(mainWallet) {
    return (dispatch) => {
        dispatch({ type: walletConstant.UPDATE_WALLET, payload: { mainWallet } });
    };
}

function fetchMainWallet({ isReload } = {}) {
    return async (dispatch, getState) => {
        const state = getState();

        const { wallet } = state;
        const isSeamless = state.seamless?.isSeamless;

        if (!isReload && wallet.walletFetchStatus !== 'idle') {
            return;
        }

        dispatch({ type: walletConstant.SET_WALLET_FETCH_STATUS, payload: { walletFetchStatus: 'loading' } });

        const seamlessWalletParams = {
            isRecalculate: true,
        };

        try {
            const [mainWallet] = await Promise.all([getMainWallet(isSeamless, isSeamless ? seamlessWalletParams : {})]);
            if (isSeamless) {
                dispatch({ type: seamlessConstant.GET_MEMBER_WALLET, payload: { memberWallet: mainWallet } });
            } else {
                dispatch({ type: walletConstant.UPDATE_WALLET, payload: { mainWallet } });
            }
        } catch (err) {
            console.error(err);
        } finally {
            dispatch({ type: walletConstant.SET_WALLET_FETCH_STATUS, payload: { walletFetchStatus: 'complete' } });
        }
    };
}

function fetchProviderWallets({ isReload } = {}) {
    return async (dispatch, getState) => {
        const state = getState();

        const {
            seamless: { isSeamless } = {},
            menuSlice: {
                processedBaseMenuSettings: { subCategoryMenus },
            },
            wallet,
        } = state;

        if (wallet.providerWalletsFetchStatus !== 'idle' && !isReload) {
            return;
        }

        dispatch({ type: walletConstant.SET_PROVIDER_WALLETS_FETCH_STATUS, payload: { providerWalletsFetchStatus: 'loading' } });

        try {
            const [providerWallets, seamlessProviders] = await Promise.all([
                isSeamless ? getMemberWalletProviderWalletSeamless() : getMemberProviderWallet(),
                isSeamless ? getMemberWalletSeamlessProvider() : Promise.resolve(null),
            ]);
            if (providerWallets?.length > 0) {
                dispatch({ type: walletConstant.UPDATE_PROVIDER_WALLETS, payload: { providerWallets } });
                const _walletsByProvider = providerWallets.reduce((acc, item) => {
                    if (!item.provider) return acc;
                    acc[item.provider] = item;
                    return acc;
                }, {});
                const categorizedProviderWallets = Object.entries(subCategoryMenus).reduce((result, [category, feProviders]) => {
                    result[category] = feProviders
                        .map((feProvider) => {
                            // BE return response could be contain transfer + seamless, hence, need use seamlessProviders to filter if exist. (Unless BE enhance this API)
                            if (_walletsByProvider[feProvider.provider] && !seamlessProviders?.[category]?.includes(feProvider.provider)) {
                                return _walletsByProvider[feProvider.provider];
                            }
                        })
                        .filter(Boolean);
                    return result;
                }, {});

                Object.keys(categorizedProviderWallets).forEach((key) => {
                    if (!categorizedProviderWallets[key] || categorizedProviderWallets[key].length === 0) {
                        delete categorizedProviderWallets[key];
                    }
                });

                if (isSeamless) {
                    dispatch({ type: seamlessConstant.UPDATE_SEAMLESS_TRANSFER_WALLETS, payload: { seamlessTransferWallets: categorizedProviderWallets } });
                } else {
                    dispatch({ type: walletConstant.SET_CATEGORIZED_PROVIDER_WALLETS, payload: { categorizedProviderWallets } });
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            dispatch({ type: walletConstant.SET_PROVIDER_WALLETS_FETCH_STATUS, payload: { providerWalletsFetchStatus: 'complete' } });
        }
    };
}

function updateProviderWallets(providerWallets) {
    // NOTE: filter main wallet
    providerWallets = providerWallets.filter((a) => a.provider !== null);
    return (dispatch) => {
        dispatch({ type: walletConstant.UPDATE_PROVIDER_WALLETS, payload: { providerWallets } });
    };
}

function updateDepositWithdrawDecimalSettings() {
    return (dispatch, getState) => {
        const { user } = getState();
        return new Promise(function (resolve) {
            window.SPL_Member.getMemberDepositWithdrawDecimalSettings({
                memberId: user?.account?.id,
            }).then((res) => {
                dispatch({
                    type: walletConstant.UPDATE_DEPOSIT_WITHDRAW_DECIMAL_SETTINGS,
                    payload: { decimalSettings: res },
                });
                resolve();
            });
        });
    };
}
